import React, { useRef, useEffect, useState } from 'react'

export const SCROLL_THRESHOLD = 3000

export type BackToTopProps = {
  testId?: string
}

export const BackToTop = (props: BackToTopProps) => {
  const { testId } = props
  const backToTopBtnRef = useRef<HTMLButtonElement>(null)
  const oldScroll = useRef(0)
  const [showBackToTop, setShowBackToTop] = useState(false)

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop

    if (scrollTop <= SCROLL_THRESHOLD) {
      oldScroll.current = scrollTop
      setShowBackToTop(false)
      return
    }

    if (scrollTop > oldScroll.current) {
      oldScroll.current = scrollTop
      setShowBackToTop(false)
      return
    }

    if (scrollTop < oldScroll.current) {
      setShowBackToTop(true)
    }

    oldScroll.current = scrollTop
  }

  const triggerScrollEvent = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <nav
      className={`BackToTop u-md-hidden u-lg-hidden ${showBackToTop ? 'is-shown' : 'is-hidden'}`}
      data-testid={testId || null}
      aria-label='Back to top'
    >
      <button
        className='BackToTop-button u-bgColorBrand'
        title='Back to top'
        ref={backToTopBtnRef}
        onClick={triggerScrollEvent}
        aria-label='Back to top'
      >
        <span
          className='adel-material-symbols-36 BackToTop-icon u-textColorWhite'
          aria-hidden='true'
        >
          keyboard_control_key
        </span>
        <br />
        <span className='BackToTop-topText u-textColorWhite'>Top</span>
      </button>
    </nav>
  )
}
